import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import { QlPickerContainer } from '../../../artboard/Toolbar/styles';
import ColorPicker from '../../../artboard/ColorPicker';
import { TEXT_BLOCK_TOOLBAR } from '../../../artboard/Toolbar/translationValues';

const NAMESPACES = ['TEXT_BLOCK_TOOLBAR'];

const preventDefault = e => {
  if (e.target.tagName !== 'INPUT') {
    e.preventDefault();
  }
}

const renderColorPicker = (type, { color, setColor, setPicker, styles = {} }) => {
  return (
    <QlPickerContainer style={styles} id={`${type}-picker`}
      onMouseMove={preventDefault}
      onMouseDown={preventDefault}
    >
      <ColorPicker
        qlEditor={true}
        onChange={(e, fromInput = false) => {
          console.log('color Picker', e, type);
          setColor(e.hex, fromInput);
        }}
        onBlur={() => setPicker(null)}
        color={color || '#000'}
      />
    </QlPickerContainer>
  );
};

const ColorFormat = ({ t, itemUUID,editorRef,toolbar }) => {
  const [picker, setPicker] = useState(null);
  const [color, setColor] = useState(null);
  const currentSelection = useRef(null);

  useEffect(() => {
    const selectedToolbar = (toolbar === 'textBlockToolBar' ? document.querySelector(`#toolbar-${itemUUID}`) : document.querySelector(`#htmltoolbar-${itemUUID}`));
    if (!selectedToolbar) return;
    let colorButton = selectedToolbar.querySelector('.ql-color');
    let target = null;
    if (colorButton) {
      target = colorButton.querySelectorAll('line');
      if (target.length > 0) {
        target[0].setAttribute('style', `stroke: ${color};`);
      }
    }
  }, [color]);

  const setColorInEditor = useCallback((newColor, fromInput = false) => {
    setColor(newColor);
    if(newColor){
        const editor =  editorRef?.current.getEditor();
        if(editor)
        {
          if (fromInput && currentSelection.current !== null) {
            const focus = editor.root?.focus({
              preventScroll: true
            });
            editor.setSelection(currentSelection.current);
          }
          editor.format('color', newColor, 'user');
        }
    }
  }, []);

  return (
    <Tooltip
      placement="top"
      title={t(
        TEXT_BLOCK_TOOLBAR.TEXT_COLOR_TOOLTIP.key,
        TEXT_BLOCK_TOOLBAR.TEXT_COLOR_TOOLTIP.value,
      )}
    >
      <div style={{ position: 'relative' }}>
        <div
          id='custom-format-div'
          className={'hide-picker'}
          style={{ height: 30 }}
          onMouseDown={(e) => {
            e.preventDefault();
            if (picker === null) {
              const editor = editorRef?.current?.getEditor();
              const focus = editor.root?.focus({
                preventScroll: true
              });
              currentSelection.current = editor?.getSelection(true);
              const existingColor = editor.getFormat(currentSelection.current)?.color;
              setColor(() => {
                setPicker('color');
                return existingColor;
              });
            } else {
              currentSelection.current = null;
              setPicker(null);
            }
          }}
        >
          <select
            className="ql-color custom-picker  ql-format-style"
          />
        </div>
       {picker === 'color' &&
         renderColorPicker('color', {
           color,
           setColor: setColorInEditor,
           setPicker,
           styles: { position: 'absolute', top: 30, left: 0 }
         })}
      </div>
    </Tooltip>
  );
};

export default withTranslation(NAMESPACES)(ColorFormat);
